import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

/**
 * SheerID verification form locale param.
 * Use language code (and region only for English variants), never country code.
 * @see https://sheerid.zendesk.com/hc/en-us/articles/13361305135899-Countries-and-languages#h_01HBYZZKQ9HPNVSPR42RXBZCS5
 *
 * - en-us → en-US (English America)
 * - es-us, es-* → es (Spanish Latin America)
 * - en-gb, en-ie, en-au → en-GB
 * - else → language only (fr, de, etc.)
 */

export function getSheerIdLocaleParam(locale: string): string {
  const { language, region } = new Intl.Locale(locale)
  const regionCode = region?.toUpperCase()

  if (language !== 'en') return language
  if (regionCode === MarketCountryCode.US) return 'en-US'
  if (
    [MarketCountryCode.GB, MarketCountryCode.IE, MarketCountryCode.AU].includes(
      regionCode as MarketCountryCode,
    )
  ) {
    return 'en-GB'
  }

  return language
}
